import { RefreshCw, WifiOff } from "lucide-react";

// Shown instead of an empty page whenever the API can't be reached.
export const LoadError = ({ onRetry, message = "We couldn't load this content right now.", testid = "load-error" }) => (
  <div role="alert" data-testid={testid}
    className="rounded-2xl border border-[#273042] bg-[#121620] p-8 sm:p-10 text-center">
    <WifiOff className="w-9 h-9 text-[#E11D2A] mx-auto mb-3" aria-hidden="true" />
    <div className="text-white font-bold text-lg">{message}</div>
    <p className="text-slate-300 text-sm mt-1">Please check your connection and try again.</p>
    {onRetry && (
      <button onClick={onRetry} data-testid={`${testid}-retry`}
        className="mt-5 h-11 px-6 rounded-full bg-[#E11D2A] hover:bg-[#C8121F] text-white font-bold inline-flex items-center gap-2 transition-colors">
        <RefreshCw className="w-4 h-4" aria-hidden="true" /> Try again
      </button>
    )}
  </div>
);
